(function() {
    'use strict';

    angular
        .module('backApp')
        .config(localStorageConfig);

    localStorageConfig.$inject = ['$localStorageProvider', '$sessionStorageProvider'];

    function localStorageConfig($localStorageProvider, $sessionStorageProvider) {
        $localStorageProvider.setKeyPrefix('back-');
        $sessionStorageProvider.setKeyPrefix('back-');
    }
})();
